<template>
  <!-- MENU CONTAINER SECTION BACKGROUND -->
  <div class="menu_container_section_background">
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- MENU CONTAINER SECTION CONTAINER -->
    <div class="menu_container_section_background">
      <div class="col-md-12 menu_container_section_container">
        <div v-for="(menu, index) in itensMenuLancarNota" :key="index" class="menu_container_section_"
          @click="handleClick(menu)">
          <div v-if="menu.novo == 1" class="novo-badge-item-menu">Novo</div>
          <figure class="menu_container_section_img">
            <img :src="menu.icon" />
          </figure>
          <div class="menu_container_section_text_container">
            <span class="menu_container_section_text_title">{{ menu.descricao }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- FIM MENU CONTAINER SECTION CONTAINER -->


  </div>
  <!-- FIM MENU CONTAINER SECTION BACKGROUND -->
</template>
<script>
import Swal from "sweetalert2";
import axios from "../../../plugins/axios";
const ls = require('local-storage')
import ItensMenuUtilitarios from '@/utilitarios/ItensMenuUtilitarios';
import ItensMenuService from "@/services/ItensMenuService";
export default {
  data: () => ({
    itensMenuLancarNota: [],
    isLoading: false,
    menusAll: [],
    menusUsuario: [],
    dialog: false,
    tiposNota: [],
    Listaranoslectivo: [],
    editedItem: {
      anolectivo: null,
      tipoNota: null,
    },
    defaulItem: {
      anolectivo: null,
      tipoNota: null,
    },
    temAcessoInstituicao: true
  }),
  async created() {
    this.isLoading = true;
    try {
      this.itensMenuLancarNota = await ItensMenuUtilitarios.getItensByMenu(8);
      this.$store.state.idclasse = null;
      this.initializeAnosLectivo();
      this.getTiposNotas();
    } catch (error) {
      Swal.fire('Informação', 'Erro ao carregar a página!', 'error');
    } finally {
      this.isLoading = false;
    }
  },

  computed: {
    islicencaExpirada() {
      return ls.get('licencaExpirada')
    }
  },

  methods: {
    async handleClick(menu) {
      // 1️⃣ Validação de licença
      if (this.isLicencaExpirada == 1) {
        Swal.fire(
          'Informação',
          'A sua licença de utilização está expirada! Por favor, entre em contato com o administrador do sistema.',
          'info'
        );
        return;
      }

      // 2️⃣ Validação de acesso da instituição
      if (menu.validarInstituicao == 1) {
        const verificacao = await ItensMenuService.getAcessoMenuInstituicao(menu.id);
        this.temAcessoInstituicao = verificacao.length > 0;
      }

      console.log(menu, this.temAcessoInstituicao, ' aqui g' );
      

      if (!this.temAcessoInstituicao) {
        Swal.fire(
          'Acesso Negado',
          'A sua instituição não possui permissão para acessar esta funcionalidade. Entre em contato com os administradores do sistema para mais informações.',
          'info'
        );
        this.temAcessoInstituicao = true;
        return;
      }

      // 3️⃣ Ação final: Navegar ou executar função
      if (menu.isRota === 1) {
        this.$router.push(menu.url);
      } else if (menu.funcao) {
        eval(menu.funcao);
      }
    },

    IndisponivelMomento() {
      Swal.fire(
        "Informação",
        "Funcionalidade indisponível de momento.",
        "warning"
      );
    },

    showDialogNotasAnteriores() {
      this.$store.state.anolectivoLancamento = this.editedItem.anolectivo;
      this.$router.push('anos-anteriores');
    },
    async initializeAnosLectivo() {
      try {
        this.Listaranoslectivo = await axios
          .get("/listarAnoLectivoAll2")
          .then((res) => res.data);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      } finally {
        this.isLoading = false;
      }
    },

    async getTiposNotas() {
      try {
        this.tiposNota = await axios
          .get("/getTipoNotas")
          .then((res) => res.data);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      } finally {
        this.isLoading = false;
      }
    }
  },
};
</script>